/* ============================================================
   SUBSCRIPTION WIDGET ENHANCEMENTS V3
   - Dynamic SAVE badge & per-serving cost
   - Hides "Auto-renews..." text when one-time is selected
   - One-time purchase click = auto add to cart
   
   INSTALL: Assets folder, then in theme.liquid before </body>:
   <script src="{{ 'subscription-calculator.js' | asset_url }}" defer></script>
   CONFIG: Change SERVINGS_PER_CONTAINER below
   ============================================================ */

(function() {
  var SERVINGS_PER_CONTAINER = 30;

  function getCard() {
    return document.querySelector('.plan_card');
  }

  /* ── DYNAMIC BADGE & PER-SERVING ── */
  function updatePricing() {
    var card = getCard();
    if (!card) return;

    var oneTimeInput = card.querySelector('input[data-radio-type="one_time_purchase"]');
    var subInput = card.querySelector('input[data-radio-type="selling_plan"]');
    if (!oneTimeInput || !subInput) return;

    var oneTimePrice = parseFloat((oneTimeInput.getAttribute('data-variant-price') || '').replace(/[^0-9.]/g, ''));
    var subPrice = parseFloat((subInput.getAttribute('data-variant-price') || '').replace(/[^0-9.]/g, ''));
    if (!oneTimePrice || !subPrice) return;

    var discountPct = Math.round(((oneTimePrice - subPrice) / oneTimePrice) * 100);
    var perServing = (subPrice / SERVINGS_PER_CONTAINER).toFixed(2);

    // Badge
    var groupName = card.querySelector('.group_name');
    if (groupName) {
      var existing = groupName.querySelector('.auto-save-badge');
      if (existing) existing.remove();
      var badge = document.createElement('span');
      badge.className = 'auto-save-badge';
      badge.textContent = 'SAVE ' + discountPct + '%';
      groupName.appendChild(badge);
    }

    // Per-serving
    var subSpan = card.querySelector('.group_list .group_list_item span');
    if (subSpan) {
      var existingPs = subSpan.querySelector('.auto-per-serving');
      if (existingPs) existingPs.remove();
      var ps = document.createElement('span');
      ps.className = 'auto-per-serving';
      ps.textContent = ' · ~$' + perServing + '/serving';
      subSpan.appendChild(ps);
    }
  }

  /* ── HIDE "Auto-renews..." WHEN ONE-TIME SELECTED ── */
  function findAutoRenewText() {
    // The "Auto-renews, skip or cancel anytime." text is rendered
    // by the Shopify subscriptions app near the .plan_card.
    // We search siblings and nearby elements for it.
    var card = getCard();
    if (!card) return null;

    var parent = card.parentElement;
    if (!parent) return null;

    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el === card) continue;
      if (el.textContent && el.textContent.trim().toLowerCase().indexOf('auto-renew') !== -1) {
        return el;
      }
    }

    // Also check next siblings of card
    var next = card.nextElementSibling;
    while (next) {
      if (next.textContent && next.textContent.trim().toLowerCase().indexOf('auto-renew') !== -1) {
        return next;
      }
      next = next.nextElementSibling;
    }

    return null;
  }

  function updateAutoRenewVisibility() {
    var card = getCard();
    if (!card) return;

    var autoRenewEl = findAutoRenewText();
    if (!autoRenewEl) return;

    var oneTimeInput = card.querySelector('input[data-radio-type="one_time_purchase"]');
    if (oneTimeInput && oneTimeInput.checked) {
      autoRenewEl.style.display = 'none';
    } else {
      autoRenewEl.style.display = '';
    }
  }

  /* ── ONE-TIME PURCHASE = AUTO ADD TO CART ── */
  function setupOneTimeAutoAdd() {
    var card = getCard();
    if (!card) return;

    var oneTimeGroup = card.querySelector('.subscription_group:has(.one_time_purchase_option_app_block)');
    if (!oneTimeGroup) {
      // Fallback: find the group containing one_time radio
      var groups = card.querySelectorAll('.subscription_group');
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].querySelector('.one_time_purchase_option_app_block')) {
          oneTimeGroup = groups[i];
          break;
        }
      }
    }
    if (!oneTimeGroup) return;
    if (oneTimeGroup.dataset.autoAddBound) return; // prevent double-binding
    oneTimeGroup.dataset.autoAddBound = 'true';

    oneTimeGroup.addEventListener('click', function(e) {
      // Select the one-time radio
      var radio = oneTimeGroup.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Small delay to let Shopify process the radio change, then submit
      setTimeout(function() {
        // Find the add-to-cart form
        var form = document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"], .shopify-product-form');
        if (form) {
          // Clear selling plan input so it's a one-time purchase
          var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
          if (sellingPlanInput) {
            sellingPlanInput.value = '';
          }

          // Try the product-form-component's submit if available
          var productForm = form.closest('product-form-component');
          if (productForm && typeof productForm.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            // Use fetch to add to cart via AJAX
            var variantInput = form.querySelector('input[name="id"]');
            if (variantInput) {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{
                    id: parseInt(variantInput.value),
                    quantity: 1
                  }]
                })
              }).then(function() {
                // Redirect to cart
                window.location.href = '/cart';
              });
            }
          }
        }
        updateAutoRenewVisibility();
      }, 150);
    });
  }

  /* ── LISTEN FOR RADIO CHANGES ── */
  function setupRadioListeners() {
    var card = getCard();
    if (!card) return;

    card.addEventListener('change', function(e) {
      if (e.target.type === 'radio') {
        updateAutoRenewVisibility();
      }
    });
  }

  /* ── INIT ── */
  function init() {
    updatePricing();
    updateAutoRenewVisibility();
    setupOneTimeAutoAdd();
    setupRadioListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for widget re-renders (variant changes etc.)
  var observer = new MutationObserver(function() {
    updatePricing();
    updateAutoRenewVisibility();
    setupOneTimeAutoAdd();
  });

  function startObserving() {
    var card = getCard();
    if (card && card.parentElement) {
      observer.observe(card.parentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-variant-price', 'checked']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();